import { render, staticRenderFns } from "./custom-company-header.vue?vue&type=template&id=a353be22&scoped=true&"
import script from "./custom-company-header.vue?vue&type=script&lang=js&"
export * from "./custom-company-header.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-header.vue?vue&type=style&index=0&id=a353be22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a353be22",
  null
  
)

export default component.exports